export default import.meta.ROLLDOWN_FILE_URL_8HSUfh7cJHNFxCkInNzNXw